import { reactive } from 'vue';

export interface Toast {
  id: number;
  kind: 'success' | 'error' | 'info';
  message: string;
}

const toasts = reactive<Toast[]>([]);
let nextId = 1;

export function useToast() {
  const push = (kind: Toast['kind'], message: string) => {
    const id = nextId++;
    toasts.push({ id, kind, message });
    setTimeout(() => dismiss(id), kind === 'error' ? 7000 : 3500);
  };
  const dismiss = (id: number) => {
    const index = toasts.findIndex((t) => t.id === id);
    if (index >= 0) toasts.splice(index, 1);
  };
  return {
    toasts,
    dismiss,
    success: (m: string) => push('success', m),
    error: (m: string) => push('error', m),
    info: (m: string) => push('info', m),
  };
}
